import { render, staticRenderFns } from "./DetailedImage.vue?vue&type=template&id=2a1aa9fe&scoped=true&"
import script from "./DetailedImage.vue?vue&type=script&lang=js&"
export * from "./DetailedImage.vue?vue&type=script&lang=js&"
import style0 from "./DetailedImage.vue?vue&type=style&index=0&id=2a1aa9fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1aa9fe",
  null
  
)

export default component.exports